import { render, staticRenderFns } from "./PageCatalyst.vue?vue&type=template&id=5b0efa57&scoped=true&lang=pug&"
import script from "./PageCatalyst.vue?vue&type=script&lang=js&"
export * from "./PageCatalyst.vue?vue&type=script&lang=js&"
import style0 from "./PageCatalyst.vue?vue&type=style&index=0&id=5b0efa57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0efa57",
  null
  
)

export default component.exports